<section class="solicitante">
  <h2 class="solicitante__title">Quem Solicitou?</h2>
  <div class="solicitante__options">
    <app-button-selector *ngFor="let item of solicitantes" [data]="item" [(selected)]="solicitante" (selectedChange)="onSolicitanteChange()">
    </app-button-selector>
  </div>
</section>